<div class="user-area-bar">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 d-flex align-items-center justify-content-between">
        <div>
          <!-- <div class="logo d-md-none" /> -->
        </div>
        <!-- *ngIf="this.commonService?.pages?.accedi" -->
        <div  class="user-info d-flex align-items-center">
          <!-- <div  class="button-group text-left pt-4">
            <a class="btn btn-xs btn-primary" [href]="this.commonService?.pages?.accedi">Accedi</a>
          </div> -->
          <!-- <div class="languages-container">
            <div class="nav-item dropdown" dropdown (isOpenChange)="isLangaugesOpen = $event" placement="bottom right">
              <a dropdownToggle class="nav-link dropdown-toggle" data-toggle="dropdown" aria-controls="languages">
                <span>{{'languages.' + (selectedLanguage$ | async) | translate}}</span>
                <bl-icon class="icon icon-sm icon-white" [icon]="isLangaugesOpen ? 'collapse' : 'expand'"></bl-icon>
              </a>
  
              <ul id="languages" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                <ng-container *ngFor="let language of languages">
                  <li *ngIf="(selectedLanguage$ | async) != language" class="dropdown-item"
                    (click)="selectLanguage(language)">
                    {{'languages.' + language | translate}}
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>  -->
          <!-- <ng-container *ngIf="(user$ | async) as user; else doLogin">
            <div *ngIf="(activeProfile$ | async) as activeProfile" class="role-container d-none d-md-flex">
              {{activeProfile?.description}}
            </div>
            <div class="position-relative h-100" dropdown placement="bottom right"
              (isOpenChange)="revertChevrot = $event">
              <a class="btn btn-primary btn-icon d-flex align-items-center h-100 pr-0" dropdownToggle (click)="false"
                aria-controls="basic-link-dropdown ">
                <span class="rounded-icon mr-2">
                  <bl-icon [class]="'icon icon-sm icon-primary'" [icon]="'user'"></bl-icon>
                </span>
                <span class="d-none d-md-block">{{user?.name}} {{user?.surname}}</span>
                <fa-icon [icon]="['fas','chevron-down']" [ngClass]="{'revert': revertChevrot}" class="ml-2 mr-4">
                </fa-icon>
              </a>

              <ul id="dropdown-operations" *dropdownMenu class="dropdown-menu dropdown-menu-right header" role="menu"
                aria-labelledby="basic-link">
                <li *ngIf="((profiles$ | async)?.length > 1 && (activeProfile$ | async))" role="menuitem"
                  (click)="changeProfile()">
                  {{'userArea.changeProfile' | translate}}
                </li>
                <li role="menuitem" (click)="logOut()">
                  {{'userArea.logout' | translate}}
                </li>
              </ul>
            </div>
          </ng-container>
            -->
          <div *ngIf="!this.commonService?.pages?.logo_header_destra && this.commonService?.pages?.accedi" #doLogin>
              <a [href]="this.commonService?.pages?.accedi" class="btn btn-primary btn-icon btn-full h-100 py-3 py-md-0">
                <span class="rounded-icon">
                  <bl-icon style="transform: rotate3d(0, 540, 90, 180deg);" [class]="'icon icon-sm icon-primary'" [icon]="'key'"></bl-icon>
                </span>
                <span aria-label="accedi" class="d-lg-block">Accedi</span>
              </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>